import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateAssetTypeMaintenanceSchedule($companyId: ID!, $attributes: AssetTypeMaintenanceScheduleAttributes!) {
    createAssetTypeMaintenanceSchedule(companyId: $companyId, attributes: $attributes) {
      assetTypeMaintenanceSchedule {
        id
        ...CreatedAssetTypeMaintenanceSchedule
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedAssetTypeMaintenanceSchedule on AssetTypeMaintenanceSchedule {
    id
    assetType {
      id
      name
    }
    maintenanceSchedule { 
      id
    }
      }
`
